/**
 * @class IndexPromotionTracker
 */
class IndexPromotionTracker {

    /**
     * @param {TrackingAnalytics} analytics
     */
    constructor(analytics) {
        this.analytics = analytics;
        this.$tabs = $('.tabs__tab');
        this.$deals = $('.ad-deal__link');
    }

    /**
     * @returns {IndexPromotionTracker}
     */
    init() {
        this.initTabViews().initPromotionClicks();
        return this;
    }

    /**
     * @returns {IndexPromotionTracker}
     */
    initTabViews() {
        this.$tabs.on('click', (event) => {
            let $li = $(event.currentTarget);

            this.trackTab($li.data('content'));
        });

        return this;
    }

    initPromotionClicks() {
        this.$deals.on('click', (event) => {
            event.preventDefault();

            let $a = $(event.currentTarget),
                deal = $a.find('.ad-deal__heading').text();
            this.analytics.trackWithCallback(

                {
                    eventName: 'Home Deal',
                    eventBody: {
                        event_category: 'Click',
                        event_label: deal,
                    }
                },
                () => window.location = $a.attr('href')
            );
        });
    }

    /**
     * @param {String} tabName
     * @returns {IndexPromotionTracker}
     */
    trackTab(tabName) {
        this.analytics.track('Home Tab', 'View', tabName);
        return this;
    }

}

export default IndexPromotionTracker;